import React, { useState, useEffect } from 'react';

const PageTransition = ({ children, type = 'door', productName = '', productColor = '#FFFFFF' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDoors, setShowDoors] = useState(true);

  useEffect(() => {
    // Show doors opening animation (even slower for dramatic effect)
    const doorTimer = setTimeout(() => {
      setShowDoors(false);
    }, 3000);

    // Show content after doors open
    const contentTimer = setTimeout(() => {
      setIsVisible(true);
    }, 2200);

    return () => {
      clearTimeout(doorTimer);
      clearTimeout(contentTimer);
    };
  }, []);

  return (
    <>
      {/* Door Opening Animation */}
      {showDoors && (
        <div className="fixed inset-0 z-[9999] pointer-events-none">
          {/* Left Door */}
          <div className="door-left absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-br from-[#8B3A3A]/20 to-transparent opacity-50"></div>
            {/* Door Details */}
            <div className="absolute top-1/2 right-8 -translate-y-1/2 w-6 h-20 bg-gradient-to-r from-amber-600 to-amber-700 rounded-full shadow-lg door-handle"></div>
            <div className="absolute inset-4 border-4 border-slate-700/50 rounded-lg"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-br from-[#8B3A3A]/10 to-transparent rounded-full blur-3xl"></div>
          </div>
          
          {/* Right Door */}
          <div className="door-right absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-slate-900 via-slate-800 to-slate-900 shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-bl from-[#8B3A3A]/20 to-transparent opacity-50"></div>
            {/* Door Details */}
            <div className="absolute top-1/2 left-8 -translate-y-1/2 w-6 h-20 bg-gradient-to-l from-amber-600 to-amber-700 rounded-full shadow-lg door-handle"></div>
            <div className="absolute inset-4 border-4 border-slate-700/50 rounded-lg"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-bl from-[#8B3A3A]/10 to-transparent rounded-full blur-3xl"></div>
          </div>

          {/* Center Glow Effect */}
          <div className="door-glow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-full bg-gradient-to-b from-transparent via-white to-transparent opacity-0"></div>
          
          {/* Product Name & Brand Text on Doors */}
          {productName && (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center z-10">
              <h2 
                className="text-4xl md:text-5xl font-black mb-4 tracking-tight drop-shadow-2xl"
                style={{ color: productColor }}
              >
                {productName}
              </h2>
              <p className="text-lg md:text-xl text-amber-400 font-bold tracking-wide drop-shadow-lg">
                By Policy Arth Labs
              </p>
            </div>
          )}
        </div>
      )}

      {/* Page Content */}
      <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        {children}
      </div>
    </>
  );
};

export default PageTransition;
